// Подкатегории раздела "Общие услуги" (Уровень 2).
// Используются в CreateTask.jsx (выбор) и TaskList.jsx (фильтр/метка).

// requires_identity_verification = true -> отклик на задание доступен только исполнителям
// с подтверждённой личностью (документальная верификация), ОБЯЗАТЕЛЬНО, заказчик это не отключает.
// Флаг заменяет прежний хардкод списка ("household", "errand") на стороне backend (server.py),
// чтобы при добавлении новой подкатегории с доступом в дом/к вещам не забыть включить верификацию.
export const GENERAL_SUBCATEGORIES = [
  {
    value: "photo_video",
    label: "Фото / видео локации",
    result_type: "media",
    location_required: true,
    requires_identity_verification: false,
    placeholder: "Опишите что и откуда нужно снять: ракурсы, освещение, время суток, важные детали...",
  },
  {
    value: "property_check",
    label: "Проверка объекта",
    result_type: "media",
    location_required: true,
    requires_identity_verification: false,
    placeholder: "Адрес объекта. Что проверить: состояние входной группы, окна, потолки, двор, шум, соседи...",
  },
  {
    value: "errand",
    label: "Личное поручение",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "Что купить / забрать / передать. Адрес откуда и куда. Особые требования и бюджет на покупку...",
  },
  {
    value: "courier",
    label: "Курьер и доставка",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "Что доставить и кому. Адрес откуда и куда. Срок доставки, контакты получателя, особые условия (хрупкое, скорость)...",
  },
  {
    value: "research",
    label: "Поиск информации",
    result_type: "text",
    location_required: false,
    requires_identity_verification: false,
    placeholder: "Что нужно найти. Где искать. В каком виде нужен ответ (список, таблица, текст со ссылками)...",
  },
  {
    value: "household",
    label: "Ремонт и сборка",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "Что нужно сделать (починить кран, собрать мебель, электрика). Адрес. Кто предоставляет инструменты и материалы...",
  },
  {
    value: "cleaning",
    label: "Уборка",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "Что убрать (квартира, офис, дача, территория). Адрес и площадь. Генеральная или поддерживающая уборка. Ваша химия или исполнителя...",
  },
  {
    value: "moving",
    label: "Грузчик и переезд",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "Что перевезти (мебель, техника, коробки). Адреса откуда и куда, этажи, наличие лифта. Нужен ли грузовой транспорт...",
  },
  {
    value: "pet_sitting",
    label: "Присмотр за питомцем / растениями",
    result_type: "action",
    location_required: true,
    requires_identity_verification: true,
    placeholder: "За кем/чем присмотреть (питомец, растения). Адрес и график. Особенности питомца, инструкции по кормлению и уходу...",
  },
  {
    value: "document",
    label: "Документ / файл",
    result_type: "document",
    location_required: false,
    requires_identity_verification: false,
    placeholder: "Что составить (текст, курсовая, презентация, таблица). Объём. Формат файла (docx, pdf, xlsx). Требования и шаблоны...",
  },
  {
    value: "consultation",
    label: "Консультация",
    result_type: "text",
    location_required: false,
    requires_identity_verification: false,
    placeholder: "Тема консультации. Какие вопросы решить. Желаемый формат ответа (письменный разбор, рекомендации)...",
  },
  {
    value: "other",
    label: "Другое",
    result_type: "media",
    location_required: true,
    requires_identity_verification: false,
    placeholder: "Подробно опишите задание: что нужно сделать, на что обратить внимание, как принять результат...",
  },
];

export const RESULT_TYPE_INFO = {
  media: "Исполнитель загрузит фото или видео результата",
  text: "Исполнитель напишет текстовый отчёт",
  action: "Исполнитель опишет, что было сделано (фото — по желанию)",
  document: "Исполнитель прикрепит готовый документ или файл",
};

// Быстрые шаблоны-пресеты: один клик заполняет подкатегорию, название и описание.
export const GENERAL_PRESETS = [
  {
    id: "buy_deliver",
    label: "Купить и доставить",
    subcategory: "errand",
    title: "Купить и доставить",
    description: "Нужно купить указанные товары и доставить по адресу. Список покупок и бюджет уточню в чате. Важно сохранить чек.",
  },
  {
    id: "pickup_order",
    label: "Забрать заказ и привезти",
    subcategory: "errand",
    title: "Забрать заказ и привезти",
    description: "Нужно забрать мой заказ из пункта выдачи или магазина и привезти по адресу. Код получения и адреса передам в чате после согласования.",
  },
  {
    id: "go_instead",
    label: "Съездить за меня",
    subcategory: "errand",
    title: "Съездить за меня по делу",
    description: "Нужно съездить по адресу вместо меня: подать или забрать документы, отстоять очередь, решить простой вопрос на месте. Детали и адрес уточню в чате.",
  },
  {
    id: "deliver_item",
    label: "Отвезти вещь или документы",
    subcategory: "errand",
    title: "Отвезти и передать",
    description: "Нужно забрать у меня вещь или документы и передать получателю в другом районе города. Адреса и контакты получателя сообщу в чате.",
  },
  {
    id: "check_flat",
    label: "Проверить квартиру перед арендой",
    subcategory: "property_check",
    title: "Проверить квартиру перед арендой",
    description: "Съездить на объект и проверить реальное состояние: ремонт, сантехника, окна, двор, район. Нужны фото и краткий отчёт о замечаниях.",
  },
  {
    id: "home_repair",
    label: "Бытовой ремонт (сантехника, мебель)",
    subcategory: "household",
    title: "Мелкий бытовой ремонт на дому",
    description: "Требуется помощь по дому: мелкий ремонт сантехники / сборка мебели / бытовые работы. Детали и адрес уточню в чате.",
  },
  {
    id: "dacha_help",
    label: "Помощь на даче (спил, уборка)",
    subcategory: "household",
    title: "Помощь на дачном участке",
    description: "Нужна физическая помощь на участке: спил деревьев, уборка территории, погрузка мусора. Инструмент обсудим отдельно.",
  },
  {
    id: "find_info",
    label: "Найти информацию",
    subcategory: "research",
    title: "Найти информацию по теме",
    description: "Нужно найти и собрать информацию по заданной теме. Ответ предоставить текстом со ссылками на источники.",
  },
  {
    id: "make_doc",
    label: "Составить документ / курсовая",
    subcategory: "document",
    title: "Составить документ",
    description: "Нужно подготовить документ (текст / курсовая / презентация / таблица). Требования, объём и формат файла уточню в чате.",
  },
  {
    id: "courier_delivery",
    label: "Доставить посылку или подарок",
    subcategory: "courier",
    title: "Доставить посылку по адресу",
    description: "Нужно забрать посылку, цветы или подарок и доставить получателю по указанному адресу. Адреса, контакты получателя и время доставки согласуем в чате.",
  },
  {
    id: "courier_urgent",
    label: "Срочная доставка документов",
    subcategory: "courier",
    title: "Срочно доставить документы",
    description: "Нужно срочно забрать документы и доставить по адресу. Время подачи, адреса и контактное лицо для передачи уточню в чате.",
  },
  {
    id: "cleaning_flat",
    label: "Уборка квартиры",
    subcategory: "cleaning",
    title: "Уборка квартиры",
    description: "Нужна генеральная или поддерживающая уборка квартиры. Площадь, количество комнат, наличие животных и особые пожелания к бытовой химии уточню в чате.",
  },
  {
    id: "cleaning_after_repair",
    label: "Уборка после ремонта",
    subcategory: "cleaning",
    title: "Уборка после ремонта",
    description: "Нужно убрать помещение после ремонтных работ: строительная пыль, мусор, мытьё поверхностей и окон. Площадь и объём работ уточню в чате.",
  },
  {
    id: "moving_help",
    label: "Помощь с переездом",
    subcategory: "moving",
    title: "Помощь с переездом",
    description: "Нужна помощь с погрузкой, перевозкой и разгрузкой вещей или мебели при переезде. Адреса откуда и куда, объём вещей и наличие транспорта уточню в чате.",
  },
  {
    id: "moving_carry",
    label: "Перенести мебель или технику",
    subcategory: "moving",
    title: "Перенести мебель / технику",
    description: "Нужно перенести тяжёлые предметы (мебель, бытовую технику) внутри помещения или между этажами. Адрес, вес и габариты предметов уточню в чате.",
  },
  {
    id: "pet_walk",
    label: "Погулять с собакой",
    subcategory: "pet_sitting",
    title: "Погулять с собакой",
    description: "Нужно погулять с собакой в моё отсутствие. Время и продолжительность прогулки, особенности питомца уточню в чате.",
  },
  {
    id: "pet_or_plant_sitting",
    label: "Присмотреть за питомцем / растениями",
    subcategory: "pet_sitting",
    title: "Присмотреть за питомцем или растениями",
    description: "Нужно присмотреть за питомцем или растениями в моё отсутствие (покормить, полить). Адрес, график и инструкции передам в чате.",
  },
];

export function getSubcategory(value) {
  return GENERAL_SUBCATEGORIES.find((s) => s.value === value) || null;
}

export function getSubcategoryLabel(value) {
  const s = getSubcategory(value);
  return s ? s.label : null;
}
